import Vue from 'vue';
import App from './App.vue';
import router from './router';
import store from './store';
import '@/plugins/vant.js';
import { Toast,Icon } from "vant";

// Components Card
import Card from '@/components/Card';
import Images from '@/components/Image';
import Tabs from '@/components/Tabs';
import TabPane from '@/components/TabPane';
import TabBar from '@/components/TabBar';
import ScrollView from '@/components/ScrollView';
import FormBox from '@/components/Form';
import Check from '@/components/Check';
import Field from '@/components/Field';
import FieldItem from '@/components/FieldItem';
import VuePicker from 'vue-pickers';


const components = [
    Card,
    Images,
    Tabs,
    TabPane,
    TabBar,
    ScrollView,
    FormBox,
    Check,
    Field,
    FieldItem,
    VuePicker,
    Icon
];

components.forEach(component => {
    Vue.use(component);
});

import '@/assets/scripts/permission';

import '@/assets/icons';
import '@/assets/scss/common.scss';

Vue.config.productionTip = false;

new Vue({
    router,
    store,
    Toast,
    render: h => h(App)
}).$mount('#app');
